import * as Types from '../../../__generated__/schema';

import { DataSchemaTeaser } from './DataSchemaTeaser.generated';
import { GraphQLError } from 'graphql';
import { gql } from '@apollo/client';
export type DataSchemaFull = Pick<
  Types.Schema,
  'spec' | 'discoveredSpec' | 'referenceURL' | 'revision' | 'version'
> &
  DataSchemaTeaser;

export const DataSchemaFull = gql`
  fragment DataSchemaFull on Schema {
    ...DataSchemaTeaser
    spec
    discoveredSpec
    referenceURL
    revision
    version
  }
  ${DataSchemaTeaser}
`;
